import React from 'react'
import { Link } from 'react-router-dom';
import { TbSettingsBolt } from "react-icons/tb";

function SkillBtn() {
    return (
        <div className="center">
            <div className="btns-center">
                <button className="secondary btn">
                    <Link to="/expertise">Full Toolkit {' '} <TbSettingsBolt className='setting'/> </Link>
                </button>
            </div>
        </div>
    )
}

export default SkillBtn